// Lodge Config action types

const lodgeConfigActionTypes = {
  ID_ME_DATA_PARAMETERS: 'ID_ME_DATA_PARAMETERS',

  SUCCESS_LODGE_CONFIG_LOADING: 'SUCCESS_LODGE_CONFIG_LOADING',

  SUCCESS_LODGE_CONFIG_LOADING_PLAN: 'SUCCESS_LODGE_CONFIG_LOADING_PLAN',

  SUCCESS_LODGE_CONFIG_USER_SETTINGS: 'SUCCESS_LODGE_CONFIG_USER_SETTINGS',

  SUCCESS_LODGE_CONFIG_LOADING_CREDIT_PACKAGE: 'SUCCESS_LODGE_CONFIG_LOADING_CREDIT_PACKAGE',

  SUCCESS_LODGE_CONFIG_LOADING_CMP: 'SUCCESS_LODGE_CONFIG_LOADING_CMP',

  SUCCESS_LODGE_CONFIG_LOADING_PAYMENT: 'SUCCESS_LODGE_CONFIG_LOADING_PAYMENT',

  SUCCESS_LODGE_CONFIG_LOADING_LEADGEN: 'SUCCESS_LODGE_CONFIG_LOADING_LEADGEN',
  RESET_LODGE_CONFIG: 'RESET_LODGE_CONFIG',

  SUCCESS_LODGE_CONFIG_LOADING_CART: 'SUCCESS_LODGE_CONFIG_LOADING_CART',

  SUCCESS_LODGE_CONFIG_LOADING_BOOKING_WIDGET: 'SUCCESS_LODGE_CONFIG_LOADING_BOOKING_WIDGET',

  SUCCESS_LODGE_CONFIG_LOADING_PARTY_BOOKING_WIDGET: 'SUCCESS_LODGE_CONFIG_LOADING_PARTY_BOOKING_WIDGET'
};

export default lodgeConfigActionTypes;
